<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Delete Account</h1>
        </template>
        
        <p>Are you sure you want to delete your account permanently? This action cannot be undone.</p>

        <template v-slot:footer>
            <p class="text-destructive mb-2" v-if="errors.general && errors.general.length > 0">{{ errors.general[0] }}</p>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-destructive text-white font-bold"
                :loading="loading"
                state="Deleting..."
                @click.native="submit"
            >
                Yes, delete my account forever!
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            errors: {},
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            axios.delete('/api/me')
            .then(response => {
                this.$emit('resolve', response);
            })
            .catch(err => {
                this.errors = err.response.data.errors;
                console.error(err);
            }).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>